<template>
  <div class="unverified">
    <div class="container-fluid">
      <div class="container-fluid pb-3">
        <h2 class="card-title font-weight-bold">Unverified Requests</h2>
        <!-- Start of Table 1 -->
        <div>
          <RequestTable
          :requests="allRequests"
          :shortTable="true"
          :unverified="true"
          :startDate="null"
          :endDate="null"
          type=""
          city=""
          :showExport="true"
          csvExportFile="export_unverified_requests"
        />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb, db } from "../firebase";
import { mapState, mapGetters } from 'vuex'
import RequestTable from "../components/RequestTable.vue";

export default {
  name: "Unverified",
  components: { RequestTable},
  props: {},
  data() {
    return {
      requests: [],
      request: {
        //Standard
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
        req_contact_first: null,
        req_contact_last: null,
        req_street: null,
        req_internal_addr: null,
        req_city: null,
        req_state: null,
        req_zip: null,
        req_street_name: null,
        req_street_number: null,
        req_submitted: null,
        timestamp: null,
      },
      activeItem: null,
      modal: null,
      collapseState: null,
      collapseCustomState: null,
      selected: "",
      selected2: "",
      selectedAddress: "",
      // Custom Add Request Props
      customFullName: null,
      customFirstName: null,
      customLastName: null,
    };
  },
  computed: {
    ...mapState([
    'bulksettings',
    'allRequests'
  ]),
    ...mapGetters({
      user: "user"
    })
  },
  methods: {
    filterAndSortData(requests) {
      var sortedByTable = [].concat(requests);;
      if (this.ascending) {
        sortedByTable = sortedByTable.sort(function (a, b) {
          return Date.parse(a.timestamp) - Date.parse(b.timestamp);
        });
      } else {
        sortedByTable = sortedByTable.sort(function (a, b) {
          return Date.parse(b.timestamp) - Date.parse(a.timestamp);
        });
      }

      /*result = result.filter((request) => {
        return request.req_zone != null && request.req_type == "Bulk";
      });*/

      return sortedByTable;
    },
    curateData(requests) {
      var curatedTable = this.filterAndSortData(requests);

      curatedTable = curatedTable.filter((request) => {
        return request.req_zone == null;
      });

      return curatedTable;
    },
    reset() {
      this.request = {
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req__pickup: null,
        req_phone: null,
        req_email: null,
      };
    },
    reset() {
      this.request = {
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
      };
    },

  },
};
</script>

<style scoped lang="scss">
</style>